import React from "react";

const RefundPolicy = () => {
  return (
    <main className="bg-gray-50 min-h-screen mt-5">
      <section id="refund-policy" className="py-16 px-4 lg:px-24">
        <div className="container mx-auto">
          <div className="text-center mb-12">
            <h1 className="text-4xl font-bold text-black">Refund Policy</h1>
          </div>

          <p className="text-lg font-semibold text-gray-700">
            Refund and Cancellation Policy for Taxi Booking Tour Packages
          </p>
          <br />

          <ol className="space-y-8">
            <li>
              <h5 className="text-2xl font-semibold text-gray-800">
                Refund Policy
              </h5>
              <p className="text-gray-600 mt-2">
                We strive to provide a seamless experience for our customers.
                However, once a booking is confirmed for any tour package, the
                payment is strictly non-refundable. This policy applies to all
                bookings, irrespective of the reason for cancellation or request
                for a refund.
              </p>
            </li>

            <li>
              <h5 className="text-2xl font-semibold text-gray-800">
                Cancellation Policy
              </h5>
              <p className="text-gray-600 mt-2">
                Once the booking is successfully made, it cannot be canceled or
                modified under any circumstances. This includes changes to the
                travel date, vehicle type, or any other aspect of the booking.
              </p>
            </li>

            <li>
              <h5 className="text-2xl font-semibold text-gray-800">
                Booking Confirmation
              </h5>
              <p className="text-gray-600 mt-2">
                A booking is deemed confirmed once the payment is successfully
                processed. At this point, the terms of this refund and
                cancellation policy come into full effect.
              </p>
            </li>

            <li>
              <h5 className="text-2xl font-semibold text-gray-800">
                Exceptions to the Policy
              </h5>
              <p className="text-gray-600 mt-2">
                While we enforce this policy strictly, exceptions may be made
                under rare and extraordinary circumstances, such as:
              </p>
              <ul className="list-disc list-inside mt-4 text-gray-600">
                <li>
                  Natural disasters (e.g., earthquakes, floods, hurricanes,
                  wildfires, tsunamis, or volcanic eruptions).
                </li>
                <li>
                  Government-imposed travel restrictions. Please note that the
                  decision to make exceptions rests solely with the company
                  Cruze and will be handled on a case-by-case basis.
                </li>
              </ul>
            </li>

            <li>
              <h5 className="text-2xl font-semibold text-gray-800">
                Customer Acknowledgment
              </h5>
              <p className="text-gray-600 mt-2">
                By completing the booking process, you acknowledge and agree to
                adhere to the terms outlined in this refund and cancellation
                policy.
              </p>
            </li>
          </ol>
        </div>
      </section>
    </main>
  );
};

export default RefundPolicy;
